import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { MODELS } from '../../model-service';
import { XFlowGraphCommands } from '../constant';
export var NsGraphToggleMultiSelect;
(function (NsGraphToggleMultiSelect) {
    /** Command: 用于注册named factory */
    NsGraphToggleMultiSelect.command = XFlowGraphCommands.GRAPH_TOGGLE_MULTI_SELECT;
    /** hookName */
    NsGraphToggleMultiSelect.hookKey = 'toggleMultiSelect';
})(NsGraphToggleMultiSelect || (NsGraphToggleMultiSelect = {}));
let GraphToggleMultiSelectCommand = class GraphToggleMultiSelectCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.toggleMultiSelect.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const config = yield this.ctx.getGraphConfig();
                const { isEnable, modelService } = handlerArgs;
                const graphEnableMultiSelectModel = yield MODELS.GRAPH_ENABLE_MULTI_SELECT.getModel(modelService);
                const needEnableRubberBand = typeof isEnable === 'boolean' ? isEnable : !x6Graph.isRubberbandEnabled();
                if (needEnableRubberBand) {
                    x6Graph.enableRubberband();
                    if (x6Graph.scroller && x6Graph.scroller.widget) {
                        x6Graph.scroller.disablePanning();
                    }
                    else {
                        x6Graph.disablePanning();
                    }
                    config.graphContainer.style.cursor = 'crosshair';
                }
                else {
                    x6Graph.disableRubberband();
                    if (x6Graph.scroller && x6Graph.scroller.widget) {
                        x6Graph.scroller.enablePanning();
                    }
                    else {
                        x6Graph.enablePanning();
                    }
                    config.graphContainer.style.cursor = 'grab';
                }
                graphEnableMultiSelectModel.setValue({ isEnable: needEnableRubberBand });
                return { isEnable: needEnableRubberBand };
            }), 
            /** execute command 时创建的hook */
            runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphToggleMultiSelectCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphToggleMultiSelectCommand.prototype, "init", null);
GraphToggleMultiSelectCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphToggleMultiSelect.command.id },
    })
    /** 画布缩放命令 */
], GraphToggleMultiSelectCommand);
export { GraphToggleMultiSelectCommand };
//# sourceMappingURL=graph-toggle-multi-select.js.map